import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Nav, NavItem, NavLink, TabContent, TabPane, Alert } from 'reactstrap';
import classnames from 'classnames';
import Loading from '../Loading';
import SplitterLayout from 'react-splitter-layout';
import IzraktenisMap from '../karte/IzraktenisMap';
import { baseinsStyle, baseinsBuferStyle, dzurUrbumiStyle, riskaObjektiByNovertejumsStyles } from './DzeramaUdensSatecesBaseinsKartina';
import { guiSet } from '../../actions/uiActions';

import RiskaNovertejumsPamatinfo from './RiskaNovertejumsPamatinfo';
import RiskaNovertejumsBaseinsSnapshot from './RiskaNovertejumsBaseinsSnapshot';
import RiskaNovertejumsObjekti from './RiskaNovertejumsObjekti';
import RiskaNovertejumsPasakumi from './RiskaNovertejumsPasakumi';
import RiskaNovertejumsParametri from './RiskaNovertejumsParametri';
import RiskaNovertejumsSledziens from './RiskaNovertejumsSledziens';
import RiskaNovertejumsDokumenti from './RiskaNovertejumsDokumenti';
import DzeramaUdensSatecesBaseinsKopsavilkums from './DzeramaUdensSatecesBaseinsKopsavilkums';

const baseTabCfgs = [
    { key: 'pamatinfo', title: 'Pamatinformācija', comp: RiskaNovertejumsPamatinfo },
    { key: 'baseins_snapshot', title: 'Vispārīgais raksturojums', comp: RiskaNovertejumsBaseinsSnapshot },
    { key: 'objekti', title: 'Riska objekti', comp: RiskaNovertejumsObjekti },
    { key: 'pasakumi', title: 'Pasākumi', comp: RiskaNovertejumsPasakumi },
    { key: 'parametri', title: 'Monitoringa parametri', comp: RiskaNovertejumsParametri },
    { key: 'sledziens', title: 'Slēdziens', comp: RiskaNovertejumsSledziens },
    { key: 'dokumenti', title: 'Dokumenti', comp: RiskaNovertejumsDokumenti },
];

class RiskaNovertejumsKartina extends Component {
    state = {
        activeTab: 'pamatinfo'
    };

    mapPaneSizeChange = (w) => {
        this.props.guiSet('riska_novertejums_detalizeti_karte_width', w);
    }

    toggleTab = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({ activeTab: tab });
        }
    }

    getVectorLayerCfg = () => {
        const { novertejums, objekti } = this.props;

        const baseinsGeomSnapshot = novertejums?.geom;
        const baseinsBufferSnapshot = novertejums?.geom_buffer;
        const urbumiSnapshot = novertejums?.urbumi_snapshot || [];

        const baseinsGeomFeatures = baseinsGeomSnapshot ? [{
            id: 'baseins_snapshot',
            geom: baseinsGeomSnapshot
        }] : [];

        const baseinsBufferFeatures = baseinsBufferSnapshot ? [{
            id: 'baseins_snapshot_buffer',
            geom: baseinsBufferSnapshot
        }] : [];

        const urbumiSnapshotFeatures = urbumiSnapshot.map(u => ({
            ...u,
            urb_nr_pirmavota: u.nr_pirmavota_snapshot,
            urb_adrese: u.adrese_snapshot,
            geom: u.geom_snapshot
        }));

        const riskaObjektiForMap = (objekti || []).flatMap(kat =>
            kat.riska_objekti || []
        );

        return {
            ...(baseinsBufferFeatures.length > 0 && {
                dzeramaUdensBaseinaBufferZone: {
                    title: 'Sateces baseina 100m buferjosla',
                    features: baseinsBufferFeatures,
                    styles: baseinsBuferStyle,
                }
            }),
            ...(baseinsGeomFeatures.length > 0 && {
                dzeramaUdensBaseinaGeometrija: {
                    title: 'Sateces baseina ģeometrija (novērtējuma brīdī)',
                    features: baseinsGeomFeatures,
                    styles: baseinsStyle,
                    zoomTo: baseinsGeomFeatures[0]?.id,
                    zoomToOnlyFirstTime: true,
                }
            }),
            ...(urbumiSnapshotFeatures.length > 0 && {
                dzeramaUdensSatecesBaseinsUrbumi: {
                    title: 'Ūdens ieguves vietas (novērtējuma brīdī)',
                    features: urbumiSnapshotFeatures,
                    styles: dzurUrbumiStyle,
                    tooltipFunc: (feat) => `${feat.get('urbumi_id')}: ${feat.get('urb_nr_pirmavota') || ''} ${feat.get('urb_adrese') || ''}`,
                }
            }),
            ...(riskaObjektiForMap.length > 0 && {
                riskaObjekti: {
                    title: 'Riska objekti',
                    features: riskaObjektiForMap,
                    styles: riskaObjektiByNovertejumsStyles,
                    tooltipFunc: feat => `${feat.get('nosaukums_display') || feat.get('kategorija')}: ${feat.get('nosaukums') || feat.get('adrese') || feat.get('source_identifikators')}`,
                    selected: this.props.selectedObjektId
                }
            })
        };
    }

    getTabCfgs = () => {
        return [
            ...baseTabCfgs,
            { key: 'kopsavilkums', title: 'Kopsavilkums', comp: null }
        ];
    }

    render() {
        const { loading, error, gui, id, novertejums } = this.props;
        const { activeTab } = this.state;

        if (loading) {
            return <Loading />;
        }

        if (error) {
            return <Alert color="danger">Kļūda ielādējot datus: {error}</Alert>;
        }

        const tabCfgs = this.getTabCfgs();
        const hasRiskaObjekti = (this.props.objekti || []).some(k => k.riska_objekti?.length > 0);
        const showMapLayout = activeTab === 'objekti' && hasRiskaObjekti;
        const isArhivets = novertejums?.statuss === 'arhivēts';

        const tabContent = (
            <div className={isArhivets ? 'riska-novertejums-arhivets' : ''}>
                {isArhivets && (
                    <div style={{
                        backgroundColor: '#6c757d',
                        color: '#ffffff',
                        padding: '6px 14px',
                        borderRadius: '4px',
                        marginBottom: '8px',
                        fontWeight: 'bold'
                    }}>
                        <i className="fa fa-archive"></i>&nbsp;&nbsp;Arhivēts
                    </div>
                )}
                <Nav tabs className="mb-3">
                    {tabCfgs.map(tab => (
                        <NavItem key={tab.key}>
                            <NavLink
                                className={classnames({ active: activeTab === tab.key })}
                                onClick={() => this.toggleTab(tab.key)}
                                style={{ cursor: 'pointer' }}
                            >
                                {tab.title}
                            </NavLink>
                        </NavItem>
                    ))}
                </Nav>

                <TabContent activeTab={activeTab}>
                    {tabCfgs.map(tab => {
                        if (tab.key === 'kopsavilkums') {
                            return (
                                <TabPane key={tab.key} tabId={tab.key}>
                                    <DzeramaUdensSatecesBaseinsKopsavilkums riskaNovertejumsId={id} activeTab={activeTab} />
                                </TabPane>
                            );
                        }
                        const Comp = tab.comp;
                        return (
                            <TabPane key={tab.key} tabId={tab.key}>
                                <Comp id={id} />
                            </TabPane>
                        );
                    })}
                </TabContent>
            </div>
        );

        if (showMapLayout) {
            return (
                <SplitterLayout
                    customClassName="pane-paddings-hor"
                    percentage
                    primaryIndex={0}
                    secondaryInitialSize={gui.riska_novertejums_detalizeti_karte_width || 50}
                    onSecondaryPaneSizeChange={this.mapPaneSizeChange}
                >
                    <div className="leftside">
                        {tabContent}
                    </div>
                    <div className="rightside">
                        <div className="karte-wrapper">
                            <IzraktenisMap
                                mapId="riska_novertejums_detalizeti_karte"
                                vectorLayerCfgs={this.getVectorLayerCfg()}
                            />
                        </div>
                    </div>
                </SplitterLayout>
            );
        }

        return tabContent;
    }
}

const mapStateToProps = (state) => {
    const { payload } = state.location;
    const { id } = payload || {};
    const riskaNovertejumi = state.riskaNovertejumi || {};

    return {
        id,
        novertejums: riskaNovertejumi.selectedItem,
        objekti: riskaNovertejumi.objektiList || [],
        selectedObjektId: riskaNovertejumi.selectedObjektId,
        loading: riskaNovertejumi.loading || false,
        error: riskaNovertejumi.error,
        gui: state.gui || {}
    };
};

export default connect(mapStateToProps, { guiSet })(RiskaNovertejumsKartina);
